module.exports = __webpack_public_path__ + "img/logo_ync_w@2x.dc205565.png";